import { Ss01CardPair } from "@/components/Ss01CardPair";
import { SS01_CARDS } from "@/lib/ss01-cards";

export function Ss01BlogCards() {
  return (
    <section aria-labelledby="ss01-blog-gallery" className="mt-8">
      <h2 id="ss01-blog-gallery" className="text-2xl font-bold">
        Base and parallel foil cards
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Each revealed card has a base printing and a parallel foil. Move your pointer or finger across a foil card to see
        its reflection.
      </p>

      <div className="mt-6 space-y-10">
        {SS01_CARDS.map((card) => (
          <section key={card.code} aria-labelledby={`blog-${card.code}`}>
            <h3 id={`blog-${card.code}`} className="text-lg font-bold">{card.code} · {card.nameEn}</h3>
            <p className="aeo-answer mt-2 text-sm leading-relaxed text-muted-foreground">
              {card.color}, cost {card.cost}, Power {card.power}, Strike {card.strike}. {card.effect}
            </p>
            <Ss01CardPair card={card} />
          </section>
        ))}
      </div>
    </section>
  );
}